import React from "react";
import { useState } from "react";
import { useParallax } from "react-scroll-parallax";
import { motion } from "framer-motion";
import animationData from "../../MyAnimations/Animation - 1740843597764.json"
import Lottie from "lottie-react";


const imageVariant = {
  hidden: { x: "-100vw", opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 1.5, ease: "easeOut" } },
};

const textVariant = {
  hidden: { x: 50, opacity: 0 },
  visible: (delay) => ({
    x: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut", delay },
  }),
};

const workList = [
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg",
    title: "HTML5 & CSS3",
    desc: "Building responsive and modern web interfaces with semantic HTML and advanced CSS.",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/b/ba/Javascript_badge.svg",
    title: "JavaScript & ReactJS",
    desc: "Creating dynamic and interactive user experiences with modern JavaScript frameworks.",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
    title: "Node.js & Express.js",
    desc: "Developing scalable backend services and RESTful APIs using JavaScript runtime and frameworks.",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg",
    title: "MongoDB & MySQL",
    desc: "Managing structured and unstructured databases efficiently for modern applications.",
  },
];

const techLogos = [
  "https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg",
  "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg",
  "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
  "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo.svg",
  "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
  // "https://images-cdn.openxcell.com/wp-content/uploads/2024/07/24154156/dango-inner-2.webp",
  "https://cdn-icons-png.flaticon.com/512/919/919825.png",
  "https://www.peanutsquare.com/wp-content/uploads/2024/04/Express.png",
  "https://upload.wikimedia.org/wikipedia/commons/d/db/Npm-logo.svg",
  "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
  // "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
  "https://reactnative.dev/img/header_logo.svg",
  "https://avatars.githubusercontent.com/u/12504344?s=200&v=4",
  // "https://upload.wikimedia.org/wikipedia/commons/9/91/Expo-logo.png",
];

const FullStackSection = () => {
  const parallax = useParallax({ translateY: [-24, 24], rootMargin: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);


  return (
    <section className="work-area pt-110  bg-[#292930] text-white" style={{paddingTop : isMobile && 50, paddingBottom : isMobile && 50}}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="section-title title-style-two text-center white-title mb-50">
              <h2 className="title">What I Do ?</h2>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <motion.div
            className="image-container"
            variants={imageVariant}
            initial="hidden"
            animate="visible"
            style={{ marginTop: "-50px" }}
          >
            <Lottie animationData={animationData} loop={true} style={{ width: !isMobile ? "90%" : "100%", marginTop : !isMobile ? "100px" : "30px", marginLeft : !isMobile ? "50px" : "0px"}} />

          </motion.div>

          <div className="col-lg-6">
            <div className="work-content">
              <div className="section-title title-style-two white-title">
                <span className="sub-title">Technologies</span>
                <h1 style={{fontSize : isMobile ? "28px" : "40px", color : "white"}}>Full Stack Development</h1>
              </div>

              <motion.div 
                className="tech-icons flex flex-wrap justify-center lg:justify-start mb-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ staggerChildren: 0.1, delayChildren: 0.3 }}
              >
                {techLogos.map((src, index) => (
                  <motion.div
                    key={index}
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: index * 0.05 }}
                  >
                    <img 
                      src={src} 
                      alt="Technology Logo" 
                      className="inline-block m-2 w-12 h-12 transition-transform duration-300 hover:scale-110" 
                    />
                  </motion.div>
                ))}
              </motion.div>

              <div className="work-list">
                <ul className="list-wrap">
                  {workList.map((item, index) => (
                    <motion.li
                      key={index}
                      className="p-1 mb-2 bg-[#33333b] rounded-lg border-l-4 border-blue-500 hover:bg-[#3a3a42] transition-colors duration-200"
                      variants={textVariant}
                      custom={0.2 + index * 0.2}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      style={{padding :"0px" , margin :"0px",}}
                    >
                      <div className="content">
                        <p className="text-white text-sm w-full" style={{width :"100%", padding :"0px", fontSize :"1rem"}}>{item.desc}</p>
                      </div>
                    </motion.li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="work-shape-wrap">
        <img src="/img/images/work_shape01.png" alt="" />
        <img src="/img/images/work_shape02.png" alt="" ref={parallax.ref} />
        <img src="/img/images/work_shape03.png" alt="" />
        <img src="/img/images/work_shape04.png" alt="" />
        <img src="/img/images/work_shape05.png" alt="" />
      </div>
    </section>
  );
};

export default FullStackSection;